import config from "@/config";
import { useLogto } from "@logto/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated, signIn, isLoading } = useLogto();

  if (isLoading) {
    return <div className="p-2">Loading...</div>;
  }

  if (isAuthenticated) {
    navigate({ to: "/" });
    return null;
  }

  signIn(config.FRONTEND_URL + config.LOGTO_CALLBACK);
  return null;
};

export const Route = createFileRoute("/login")({
  component: Login,
});
